<div class="chat-mi">
  <div class="chat-mi__header">
    <app-chat-mi-field-label
      [name]="field.name"
      [mandatory]="isMandatory"
      [description]="field.description"
    ></app-chat-mi-field-label>
  </div>

  @if (isDropdown) {
    <div class="chat-mi__field chat-mi__field--select">
      <select
        class="chat-mi__control"
        [attr.aria-label]="field.name"
        (change)="onDropdownChange($any($event.target).value)"
      >
        <option value="" i18n="@@chatMiSelectField">Select {{ field.name | lowercase }}…</option>
        @for (value of field.availableValues; track value.id) {
          <option [value]="value.id" [selected]="selectedMiValue?.id === value.id">
            {{ value.label ? value.value + ' (' + value.label + ')' : value.value }}
          </option>
        }
      </select>
    </div>
  }

  @if (isAutoSuggest) {
    <div class="chat-mi__field chat-mi__field--search">
      <input
        #autosuggestInput="ngbTypeahead"
        type="text"
        class="chat-mi__control"
        [attr.aria-label]="field.name"
        [(ngModel)]="selectedMiValue"
        [ngbTypeahead]="search"
        [inputFormatter]="formatValue"
        [resultFormatter]="formatValue"
        [editable]="false"
        (selectItem)="onAutoSuggestSelect($event.item)"
        (focus)="autosuggestClick$.next($any($event.target).value)"
        (click)="autosuggestClick$.next($any($event.target).value)"
        i18n-placeholder="@@chatMiSearchByCodeOrName"
        placeholder="Search {{ field.name | lowercase }} by code or name…"
      />
    </div>
  }

  @if (isFreeText) {
    <div class="chat-mi__field">
      <input
        type="text"
        class="chat-mi__control"
        [attr.aria-label]="field.name"
        [(ngModel)]="textValue"
        i18n-placeholder="@@chatMiEnterField"
        placeholder="Enter {{ field.name | lowercase }}…"
      />
      @if (showFormatHint) {
        <div class="chat-mi__hint" i18n="@@chatMiFormatHint">Doesn't match the required format</div>
      }
    </div>
  }

  @if (error) {
    <div class="chat-mi__error" role="alert" aria-live="assertive">{{ error }}</div>
  }

  <div class="chat-mi__actions">
    @if (!isMandatory) {
      <button type="button" class="chat-mi__skip" (click)="onSkip()" i18n="@@chatMiSkip">
        Skip
      </button>
    }
    <button
      type="button"
      class="chat-mi__continue"
      [disabled]="!isValid"
      (click)="onContinue()"
      i18n="@@chatMiContinue"
    >
      Continue
    </button>
  </div>
</div>
